export default __webpack_public_path__ + "static/media/Henrietta.4cc6fb38.jpg";